import { HomeImageWheelGradientOverlay } from "../home/HomeStyles";
import {
  NotFoundButton,
  NotFoundButtonLink,
  NotFoundContainer,
  NotFoundText,
  NotFoundTextCard,
  NotFoundTitle,
} from "./NotFoundStyles";

function NotFound() {
  return (
    <NotFoundContainer>
      <HomeImageWheelGradientOverlay />

      <NotFoundTextCard>
        <NotFoundTitle>
          Excuses, wij kunnen deze pagina helaas niet vinden.
        </NotFoundTitle>
        <NotFoundText>
          Helaas kunnen we de pagina die u zoekt niet vinden. Dit kan komen
          doordat de pagina niet meer bestaat, of doordat een typefout is
          gemaakt bij het invoeren van het adres.
        </NotFoundText>
        <NotFoundButtonLink href="/">
          <NotFoundButton>Terug naar de home pagina</NotFoundButton>
        </NotFoundButtonLink>
      </NotFoundTextCard>
    </NotFoundContainer>
  );
}

export default NotFound;
